import equal from 'fast-deep-equal';

/**
 * Function which get nextSteps based on the selections made by client
 * @param clientMainSelections array of objects with all the main selections the client has made
 * @param clientSecondarySelections array of objects with all the secondary selections the client has made
 * @returns array with the client next Steps
 */
export const getProductsNextStepsNormalized = (nextStepsJson, allChoices) => {
  const finalNextSteps = [];
  if (nextStepsJson && allChoices) {
    Object.keys(allChoices).forEach((mainChoiceProductType) => {
      const mainProductJson = nextStepsJson[mainChoiceProductType];
      if (mainProductJson && mainProductJson.actions) {
        allChoices[mainChoiceProductType].forEach((choice) =>{
          const mainAction = mainProductJson.actions[choice.actionId];
          if (mainAction
            && mainAction.nextSteps
            && Array.isArray(mainAction.nextSteps)
            && mainAction.nextSteps.length > 0
          ) {
            mainAction.nextSteps.forEach((nextStep) => {
              if (!finalNextSteps.find(actualNextStep => equal(actualNextStep, nextStep))) {
                finalNextSteps.push(nextStep);
              }
            });
          }
          if(choice.secondaryChoices){
            Object.keys(choice.secondaryChoices).forEach((secondaryChoiceProductType) => {
              if (mainProductJson.products) {
                const secondaryProduct = mainProductJson.products[secondaryChoiceProductType];
                if (secondaryProduct) {
                  choice.secondaryChoices[secondaryChoiceProductType].forEach((secondaryChoice) =>{
                    const secondaryAction = secondaryProduct.actions[secondaryChoice.actionId];
                    if (secondaryAction
                      && secondaryAction.nextSteps
                      && Array.isArray(secondaryAction.nextSteps)
                      && secondaryAction.nextSteps.length > 0
                    ) {
                      secondaryAction.nextSteps.forEach((nextStep) => {
                        if (!finalNextSteps.find(actualNextStep => equal(actualNextStep, nextStep))) {
                          finalNextSteps.push(nextStep);
                        }
                      });
                    }
                  })
                }
              }
            });
          }
        })
      }
    });
  } else if(nextStepsJson){
    const mainProductJson = nextStepsJson.DEFAULT;
      if (mainProductJson?.nextSteps
        && Array.isArray(mainProductJson.nextSteps)
        && mainProductJson.nextSteps.length > 0
      ) {
        mainProductJson.nextSteps.forEach((nextStep) => {
          if (!finalNextSteps.find(actualNextStep => equal(actualNextStep, nextStep))) {
            finalNextSteps.push(nextStep);
          }
        });
      }
  }
  return finalNextSteps;
};

/**
 * Function which get nextSteps based on the selections made by client
 * @param termsSelected object with every term selected by client
 * @returns array with the client next Steps
 */
export const getTermsNextStepsNormalized = (nextStepsJson, termsSelected) => {
  const { poshtSelected, poitSelected, poptSelected } = termsSelected;
  const finalNextSteps = [];
  if (nextStepsJson && nextStepsJson.terms) {
    const termsNextSteps = nextStepsJson.terms;
    if (termsNextSteps.POShT && poshtSelected) {
      if (termsNextSteps.POShT[poshtSelected]
        && termsNextSteps.POShT[poshtSelected].nextSteps
        && Array.isArray(termsNextSteps.POShT[poshtSelected].nextSteps)
        && termsNextSteps.POShT[poshtSelected].nextSteps.length > 0
      ) {
        finalNextSteps.push(...termsNextSteps.POShT[poshtSelected].nextSteps);
      }
    }
    if (termsNextSteps.POIT && poitSelected) {
      if (termsNextSteps.POIT[poitSelected]
        && termsNextSteps.POIT[poitSelected].nextSteps
        && Array.isArray(termsNextSteps.POIT[poitSelected].nextSteps)
        && termsNextSteps.POIT[poitSelected].nextSteps.length > 0
      ) {
        finalNextSteps.push(...termsNextSteps.POIT[poitSelected].nextSteps);
      }
    }
    if (termsNextSteps.POPT && poptSelected) {
      if (termsNextSteps.POPT[poptSelected]
        && termsNextSteps.POPT[poptSelected].nextSteps
        && Array.isArray(termsNextSteps.POPT[poptSelected].nextSteps)
        && termsNextSteps.POPT[poptSelected].nextSteps.length > 0
      ) {
        finalNextSteps.push(...termsNextSteps.POPT[poptSelected].nextSteps);
      }
    }
  }
  return finalNextSteps;
};

/**
 * Function which get nextSteps based on the selections made by client
 * @param poArray array of poId of the process
 * @returns array with the client next Steps
 */
export const getPONextStepsNormalized = (nextStepsJson, poIdsArray) => {
  const poFinalNextSteps = [];
  const finalConfirmationTexts = [];
  if (nextStepsJson && nextStepsJson.byProductOffering) {
    const poWithTexts = nextStepsJson.byProductOffering;
    const poNextStepsIds = Object.keys(poWithTexts);
    const commonPOs = poNextStepsIds.filter(elemento => poIdsArray.includes(elemento));

    commonPOs.forEach((poId) => {
      if (poWithTexts[poId]
        && poWithTexts[poId].nextSteps
        && Array.isArray(poWithTexts[poId].nextSteps)
        && poWithTexts[poId].nextSteps.length > 0
      ) {
        poFinalNextSteps.push(...poWithTexts[poId].nextSteps);
      }
      if (poWithTexts[poId]
        && poWithTexts[poId].confirmationTexts
        && Array.isArray(poWithTexts[poId].confirmationTexts)
        && poWithTexts[poId].confirmationTexts.length > 0
      ) {
        finalConfirmationTexts.push(...poWithTexts[poId].confirmationTexts);
      }
    });
  }
  return { poFinalNextSteps, finalConfirmationTexts };
};
